import styled, { css } from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { useLingui } from '@lingui/react/macro';
import { isToday } from 'date-fns';
import { capitalize } from 'es-toolkit';
import { Title2 } from '../components/typography';
import { useDatetimeFormat } from '../utils/use-datetime-format';
import { useWidgetDimensions } from '../widget-dimensions-provider';
import { useDatetime } from './datetime-provider';

export function CurrentDay() {
  const { selectedDay } = useDatetime();
  const { t } = useLingui();
  const { formatWeekday, formatDate } = useDatetimeFormat();
  const { isMobile } = useWidgetDimensions();

  if (!selectedDay) {
    return null;
  }

  return (
    <Content _isMobile={isMobile}>
      {isToday(selectedDay.date)
        ? t`today`.replace(/\S+/g, capitalize)
        : formatWeekday(selectedDay.date, 'long')}
      , {formatDate(selectedDay.date)}
    </Content>
  );
}

const Content = styled(Title2).attrs({
  className: createReadableClass({
    component: 'current-day',
    element: 'content'
  })
})<{
  _isMobile?: boolean;
}>`
  ${({ _isMobile }) =>
    _isMobile &&
    css`
      font-size: 15px;
    `}
`;
